export default __webpack_public_path__ + "static/clock-9e9acda48750788ef15bce4bdeaaacf2.svg";